import { createFeatureSelector } from '@ngrx/store';

export const routerState = createFeatureSelector<OLO.State, OLO.State.Router>('router');
